<template>
  <div class="popin" :class="{'is-active': isActive }">
    <div class="popin-container">
      <button type="button" @click="onClose" class="popin-close">
        <i class="ic ic-close"></i>
      </button>
      <div class="popin-content">
        <h1 class="popin-title">{{ Translator('soprasolar.project.sales_force_popin.title') }}</h1>
        <p class="project-description">
          <template v-if="step === 1">{{ Translator('soprasolar.project.sales_force_popin.step1') }}</template>
          <template v-if="step === 2">{{ Translator('soprasolar.project.sales_force_popin.step2') }}</template>
        </p>

        <template v-if="isReady">
          <p class="form-errors" v-if="error">{{ error }}</p>
          <form class="std-form" v-if="step === 1" @submit="onSubmit($event)">
            <div class="radio-element" v-for="company in companies" :key="company.Id">
              <label>
                <input type="radio" :value="company" v-model="companyValue" required />
                <span class="radio-label">
                  <strong :class="{'is-valid': company.Name.value === userDatas.company}">{{ company.Name.value }}</strong>
                  <i v-if="(company.RecordType && company.RecordType.value) || (company.TECH_Branch__c && company.TECH_Branch__c.value)">
                    (<template v-if="company.TECH_Branch__c && company.TECH_Branch__c.value">{{ company.TECH_Branch__c.value }}</template> - <template v-if="company.RecordType && company.RecordType.Name && company.RecordType.Name.value">
                      {{ getRecordType(company.RecordType.Name.value) }}
                    </template>)
                  </i><br>
                  SIREN / SIRET : <span :class="{'is-valid': company.SicDesc.value === userDatas.siren || company.SicDesc.value === userDatas.siret}">{{ format(company.SicDesc.value) }}</span><br>
                  Adresse :
                  <span :class="{'is-valid': company.BillingStreet.value === userDatas.street}"> {{ company.BillingStreet.value }} </span> -
                  <span :class="{'is-valid': company.BillingPostalCode.value === userDatas.zipCode}"> {{ company.BillingPostalCode.value }} </span>
                  <span :class="{'is-valid': company.BillingCity.value === userDatas.city}"> {{ company.BillingCity.value }} </span>
                </span>
              </label>
            </div>

            <label class="radio-element">
              <input type="radio" :value="null" v-model="companyValue" required />
              <span class="radio-label">Aucun résultat ne convient</span>
            </label>
            <div class="form-actions">
              <button type="submit" class="form-button" :disabled="isLoading">
                Suivant
                <span class="button-loader" v-if="isLoading"></span>
              </button>
            </div>
          </form>
          <form class="std-form" v-if="step === 2" @submit="onSubmit($event)">
            <fieldset>
              <legend>Informations de la société</legend>
              <table v-if="companyValue">
                <thead>
                  <tr>
                    <th></th>
                    <th>{{ Translator('soprasolar.project.sales_force_popin.datas_user') }}</th>
                    <th>{{ Translator('soprasolar.project.sales_force_popin.datas_salesforce') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ Translator('soprasolar.project.sales_force_popin.form.company') }}</td>
                    <td :colspan="companyValue.Name.value === userDatas.company ? 2 : 1">
                      <label class="radio-element">
                        <input type="radio" :value="userDatas.company" v-model="form.company" />
                        <span class="radio-label">{{ userDatas.company }}</span>
                      </label>
                    </td>
                    <td v-if="companyValue.Name.value !== userDatas.company">
                      <label class="radio-element">
                        <input type="radio" :value="companyValue.Name.value" v-model="form.company" />
                        <span class="radio-label">{{ companyValue.Name.value || '-' }}</span>
                      </label>
                    </td>
                  </tr>
                  <tr v-if="isSiretSiren === 'siret'">
                    <td>{{ Translator('soprasolar.project.sales_force_popin.form.siret') }}</td>
                    <td :colspan="companyValue.SicDesc.value === userDatas.siret ? 2 : 1">
                      <label class="radio-element">
                        <input type="radio" :value="userDatas.siret" v-model="form.siret" />
                        <span class="radio-label">{{ userDatas.siret }}</span>
                      </label>
                    </td>
                    <td v-if="companyValue.SicDesc.value !== userDatas.siret">
                      <label class="radio-element">
                        <input type="radio" :value="companyValue.SicDesc.value" v-model="form.siret" />
                        <span class="radio-label">{{ companyValue.SicDesc.value || '-' }}</span>
                      </label>
                    </td>
                  </tr>
                  <tr v-if="isSiretSiren === 'siren'">
                    <td>{{ Translator('soprasolar.project.sales_force_popin.form.siren') }}</td>
                    <td :colspan="companyValue.SicDesc.value === userDatas.siren ? 2 : 1">
                      <label class="radio-element">
                        <input type="radio" :value="userDatas.siren" v-model="form.siren" />
                        <span class="radio-label">{{ userDatas.siren }}</span>
                      </label>
                    </td>
                    <td v-if="companyValue.SicDesc.value !== userDatas.siren">
                      <label class="radio-element">
                        <input type="radio" :value="companyValue.SicDesc.value" v-model="form.siren" />
                        <span class="radio-label">{{ companyValue.SicDesc.value || '-' }}</span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ Translator('soprasolar.project.sales_force_popin.form.street') }}</td>
                    <td :colspan="companyValue.BillingStreet.value === userDatas.street ? 2 : 1">
                      <label class="radio-element">
                        <input type="radio" :value="userDatas.street" v-model="form.street" />
                        <span class="radio-label">{{ userDatas.street }}</span>
                      </label>
                    </td>
                    <td v-if="companyValue.BillingStreet.value !== userDatas.street">
                      <label class="radio-element">
                        <input type="radio" :value="companyValue.BillingStreet.value" v-model="form.street" />
                        <span class="radio-label">{{ companyValue.BillingStreet.value || '-' }}</span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ Translator('soprasolar.project.sales_force_popin.form.zip_code') }}</td>
                    <td :colspan="companyValue.BillingPostalCode.value === userDatas.zipCode ? 2 : 1">
                      <label class="radio-element">
                        <input type="radio" :value="userDatas.zipCode" v-model="form.zipCode" />
                        <span class="radio-label">{{ userDatas.zipCode }}</span>
                      </label>
                    </td>
                    <td v-if="companyValue.BillingPostalCode.value !== userDatas.zipCode">
                      <label class="radio-element">
                        <input type="radio" :value="companyValue.BillingPostalCode.value" v-model="form.zipCode" />
                        <span class="radio-label">{{ companyValue.BillingPostalCode.value || '-' }}</span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ Translator('soprasolar.project.sales_force_popin.form.city') }}</td>
                    <td :colspan="companyValue.BillingCity.value === userDatas.city ? 2 : 1">
                      <label class="radio-element">
                        <input type="radio" :value="userDatas.city" v-model="form.city" />
                        <span class="radio-label">{{ userDatas.city }}</span>
                      </label>
                    </td>
                    <td v-if="companyValue.BillingCity.value !== userDatas.city">
                      <label class="radio-element">
                        <input type="radio" :value="companyValue.BillingCity.value" v-model="form.city" />
                        <span class="radio-label">{{ companyValue.BillingCity.value || '-' }}</span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ Translator('soprasolar.project.sales_force_popin.form.company_type') }}</td>
                    <td :colspan="companyValue.TECH_SoprasolarActivity__c.value === datas.step1.occupation ? 2 : 1">
                      <label class="radio-element">
                        <input type="radio" :value="userDatas.occupation" v-model="form.companyType" />
                        <span class="radio-label">{{ datas.step1.occupation ? Translator('soprasolar.project.step1.form.occupation_options.' + datas.step1.occupation ) : '-' }}</span>
                      </label>
                    </td>
                    <td v-if="companyValue.TECH_SoprasolarActivity__c.value !== datas.step1.occupation">
                      <label class="radio-element">
                        <input type="radio" :value="companyValue.TECH_SoprasolarActivity__c.value" v-model="form.companyType" />
                        <span class="radio-label">{{ companyValue.TECH_SoprasolarActivity__c.value ? Translator('soprasolar.project.step1.form.occupation_options.' + companyValue.TECH_SoprasolarActivity__c.value ) : '-' }}</span>
                      </label>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p class="popin-description text-center" v-else>Comme l’entreprise n’existe pas, nous allons la créer dans Salesforce.</p>
            </fieldset>
            <fieldset>
              <legend>Informations du contact</legend>
              <table v-if="salesforceContact">
                <thead>
                  <tr>
                    <th></th>
                    <th>{{ Translator('soprasolar.project.sales_force_popin.datas_user') }}</th>
                    <th>{{ Translator('soprasolar.project.sales_force_popin.datas_salesforce') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ Translator('soprasolar.project.sales_force_popin.form.firstname') }}</td>
                    <td :colspan="salesforceContact.FirstName.value === userDatas.firstName ? 2 : 1">
                      <label class="radio-element">
                        <input type="radio" :value="userDatas.firstName" v-model="form.firstName" />
                        <span class="radio-label">{{ userDatas.firstName }}</span>
                      </label>
                    </td>
                    <td v-if="salesforceContact.FirstName.value !== userDatas.firstName">
                      <label class="radio-element">
                        <input type="radio" :value="salesforceContact.FirstName.value" v-model="form.firstName" />
                        <span class="radio-label">{{ salesforceContact.FirstName.value || '-' }}</span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ Translator('soprasolar.project.sales_force_popin.form.lastname') }}</td>
                    <td :colspan="salesforceContact.LastName.value === userDatas.lastName ? 2 : 1">
                      <label class="radio-element">
                        <input type="radio" :value="userDatas.lastName" v-model="form.lastName" />
                        <span class="radio-label">{{ userDatas.lastName }}</span>
                      </label>
                    </td>
                    <td v-if="salesforceContact.LastName.value !== userDatas.lastName">
                      <label class="radio-element">
                        <input type="radio" :value="salesforceContact.LastName.value" v-model="form.lastName" />
                        <span class="radio-label">{{ salesforceContact.LastName.value || '-' }}</span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ Translator('soprasolar.project.sales_force_popin.form.email') }}</td>
                    <td :colspan="salesforceContact.Email.value === userDatas.email ? 2 : 1">
                      <label class="radio-element">
                        <input type="radio" :value="userDatas.email" v-model="form.email" />
                        <span class="radio-label">{{ userDatas.email }}</span>
                      </label>
                    </td>
                    <td v-if="salesforceContact.Email.value !== userDatas.email">
                      <label class="radio-element">
                        <input type="radio" :value="salesforceContact.Email.value" v-model="form.email" />
                        <span class="radio-label">{{ salesforceContact.Email.value || '-' }}</span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ Translator('soprasolar.project.sales_force_popin.form.phone_number') }}</td>
                    <td :colspan="salesforceContact.MobilePhone.value === userDatas.phoneNumber ? 2 : 1">
                      <label class="radio-element">
                        <input type="radio" :value="userDatas.phoneNumber" v-model="form.phoneNumber" />
                        <span class="radio-label">{{ userDatas.phoneNumber }}</span>
                      </label>
                    </td>
                    <td v-if="salesforceContact.MobilePhone.value !== userDatas.phoneNumber">
                      <label class="radio-element">
                        <input type="radio" :value="salesforceContact.MobilePhone.value" v-model="form.phoneNumber" />
                        <span class="radio-label">{{ salesforceContact.MobilePhone.value || '-' }}</span>
                      </label>
                    </td>
                  </tr>

                </tbody>
              </table>
              <p class="popin-description text-center" v-else>Comme le contact n’existe pas, nous allons l'ajouter dans Salesforce.</p>
            </fieldset>

            <div class="form-actions">
              <button type="button" class="form-button" :disabled="isLoading" @click="onSubmit($event, 'all')">
                Tout synchroniser
                <span class="button-loader" v-if="isLoading"></span>
              </button>
              <button type="button" class="form-button" :disabled="isLoading" @click="onSubmit($event, 'contact')" v-if="companyValue">
                Synchroniser uniquement le contact
                <span class="button-loader" v-if="isLoading"></span>
              </button>
              <button type="button" class="form-button" :disabled="isLoading" @click="onSubmit($event, 'close')">
                Clôturer
                <span class="button-loader" v-if="isLoading"></span>
              </button>
            </div>
          </form>
        </template>
        <div class="popin-loader" v-else></div>
      </div>
    </div>
  </div>
</template>
<script>
import { gsap } from 'gsap/all';
import AppControlService from '@/soprasolar-project/services/AppControl';
import SalesForceService from '@/soprasolar-project/services/SalesForceService';
import AppControl from '@/soprasolar-project/services/AppControl';

export default {
  name: 'salesforce-popin',
  components: {},
  data () {
    return {
      step: 1,
      error: null,
      isReady: false,
      isActive: false,
      isLoading: false,
      isSiretSiren: null,
      companies: [],
      datas: AppControlService.datas,
      salesforceContact: null,
      companyValue: null,
      form: {}
    }
  },

  computed: {
    userDatas: () => {
      return AppControlService.datas.step1;
    }
  },

  created() {
    AppControlService.on('datas', this._onUpdateDatas);
  },

  beforeDestroy() {
    AppControlService.off('datas', this._onUpdateDatas);
    document.body.classList.remove('is-popin-open');
  },

  mounted() {
    document.body.classList.add('is-popin-open');
    gsap.to(window, { duration: .3, scrollTo: 0, onComplete: () => {
      this.isActive = true;
    } });
    this.getCompanies();
  },

  methods: {
    onClose() {
      AppControlService.popinSalesForceToggle(false);
    },

    getRecordType( recordType ) {
      if( recordType === 'Prospect' ) return 'Prospect';
      else if( recordType === 'Customer' ) return 'Client';
      else if( recordType === 'Influencer' ) return 'Influenceur';
    },

    format(number) {
      return AppControl.format(number);
    },

    getCodeFromTranslation(companyTypeLabel) {
      return SalesForceService.getCodeFromTranslation(companyTypeLabel);
    },

    getCompanyTypeTranslation(companyTypeLabel) {
      return companyTypeLabel;
    },

    async onSubmit(pEvt, type = null) {
      pEvt.preventDefault();
      if( this.isLoading ) return;
      this.error = null;
      this.isLoading = true;
      if( this.step === 1 ) {
        this.form = {
          ...this.userDatas,
          companyType: this.userDatas.occupation
        }
        if(this.companyValue) {
          this.salesforceContact = await SalesForceService.getContacts(this.userDatas.email);
        }
        this.step = 2;
      }
      else {
        let userDatas = {
          ...this.userDatas
        }

        if( type === 'all' ) {
          const contacts = AppControlService.contacts;
          let ownerContact = '';
          if(contacts.length > 0) ownerContact = contacts[0].email;
          const datas = {
            name: this.form.company ? this.form.company.trim() : '',
            street: this.form.street ? this.form.street.trim() : '',
            postalCode: this.form.zipCode ? this.form.zipCode.trim() : '',
            city: this.form.city ? this.form.city.trim() : '',
            companyType: this.form.companyType ? this.form.companyType.trim() : '',
            owner: ownerContact
          }
          if(this.form.siren) datas.siren = this.form.siren;
          if(this.form.siret) datas.siret = this.form.siret;

          userDatas = {
            ...userDatas,
            company: this.form.company,
            street: this.form.street,
            zipCode: this.form.zipCode,
            city: this.form.city,
            country: this.form.country
          }
          if(this.isSiretSiren === 'siret') userDatas.siret = this.form.siren;
          if(this.isSiretSiren === 'siren') userDatas.siren = this.form.siren;
          const response = await SalesForceService.setCompany(datas);
          if(response.statusCode !== 200) {
            this.isLoading = false;
            this.error = response.message;
            return;
          }
        }
        if( type === 'all' || type === 'contact' ) {
          const datas = {
            accountId: this.companyValue?.Id,
            firstname: this.form.firstName ? this.form.firstName.trim() : '',
            lastname: this.form.lastName ? this.form.lastName.trim() : '',
            email: this.form.email ? this.form.email.trim() : '',
            mobilePhone: this.form.phoneNumber ? this.form.phoneNumber.trim() : '',
          }

          userDatas = {
            ...userDatas,
            firstName: this.form.firstName,
            lastName: this.form.lastName,
            email: this.form.email,
            phoneNumber: this.form.phoneNumber,
          }
          const response = await SalesForceService.setContact(datas);
          if(response.statusCode !== 200) {
            this.isLoading = false;
            this.error = response.message;
            return;
          }
        }
        const salesforceId = this.companyValue?.Id ? this.companyValue.Id : 'true';
        await AppControl.updateWithSalesforce(salesforceId, type, userDatas);
        AppControlService.popinSalesForceToggle(false);
      }
      this.isLoading = false;
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },

    async getCompanies() {
      let companies = null;
      this.isSiretSiren = null;
      if(this.userDatas.siret) {
        companies = await SalesForceService.getCompaniesBySirenSiret(this.userDatas.siret);
        this.companies = companies;
        this.companyValue = companies[0];
        if(companies.length > 0) {
          this.isSiretSiren = 'siret';
          return this.isReady = true;
        }
      }
      if(this.userDatas.siren) {
        companies = await SalesForceService.getCompaniesBySirenSiret(this.userDatas.siren, this.userDatas.zipCode);
        this.companies = companies;
        this.companyValue = companies[0];
        if(companies.length > 0) {
          this.isSiretSiren = 'siren';
          return this.isReady = true;
        }
      }
      companies = await SalesForceService.getCompaniesByDatas(this.userDatas.company, this.userDatas.zipCode);
      this.companies = companies;

      if(companies.length > 0) this.companyValue = companies[0];
      this.isReady = true;
    },

    _onUpdateDatas(datas) {
      this.datas = datas;
    }
  }
}
</script>
<style scoped lang="scss">
  @import "~@/soprasolar-project/assets/styles/import";
  @import "~@/soprasolar-project/assets/styles/popin";
  .popin {
    .popin-title {
      text-align: left;
      font-size: rem(20);
    }
    .form-errors {
      color: $color-error;
      font-size: rem(14);
      margin-bottom: rem(15);
    }
    .project-description {
      margin-bottom: rem(30);
    }
    .popin-container {
      max-width: rem(700);
    }
    .popin-loader {
      position: relative;
      min-height: rem(200);
    }
    .popin-content {
      padding: rem(20) rem(30) rem(30);
    }
    .form-actions {
      display: flex;
      justify-content: flex-end;
      margin-top: rem(20);
      gap: rem(10);
    }
    .std-form {
      max-width: 100%;
      padding-top: 0;
      .form-button {
        @include cta;
      }
    }
    .radio-element {
      cursor: pointer;
      position: relative;
      display: flex;
      gap: rem(10);
      align-items: center;
      border: rem(1) solid $grey-light;
      border-radius: rem(4);
      margin-bottom: rem(5);
      padding: rem(5);
      padding-left: rem(40);
      min-height: rem(30);
      input[type=radio] {
        left: rem(5);
      }
      .is-valid {
        color: $color-success;
      }
      .radio-label {
        font-size: rem(14);
      }
    }
    table {
      width: 100%;
      th {
        font-size: rem(14);
        font-weight: bold;
        text-align: left;
        width: 40%;
        &:first-child {
          width: rem(130);
        }
      }
      td {
        padding: rem(5);
        font-size: rem(14);
        &:first-child {
          text-align: right;
        }
        .radio-element {
          margin-bottom: 0;
        }
      }
    }
  }
</style>
<style lang="scss">
  body.is-popin-open {
    .header {
      z-index: 1;
    }
  }
</style>